import styled from 'styled-components';
import { mixins, colors, fonts, media } from '../../../../css';

export const StyledLink = styled.a`
  cursor: pointer;
  font-size: ${mixins.pxToRem(14)};
  color: ${colors.colorGrey};
  font-family: ${fonts.fontRegular};
  text-decoration: none;
  display: flex;

  ${media.greaterThan('lg')`flex-flow: row nowrap; align-items: center; justify-items: center; height: 100%;`};

  &:hover {
    color: ${colors.colorGrey04};
  }
  figure {
    cursor: pointer !important;
  }
`;
